import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

function EmptyFeed() {
  return (
    <div className="popover-content is-empty">
      <p className="u-text-center">
        <Icon type={['far', 'bell']} color="grey" size="5x" />
        There&apos;s nothing here, yet
      </p>
    </div>
  )
}

export default EmptyFeed
